<div class="row section-row" [formGroupName]="formControlName">
  <div class="col section-col">
    <h5 class="section-heading">{{ getSeriousIncidentTypeTitle() }}</h5>
  </div>
</div>
<app-capture-details
  [parentFormGroup]="formGroup"
  [showSeriousIncident]="false"
>
</app-capture-details>
<div class="align-items-center row section-row">
  <app-yes-no
    class="col-6 section-col"
    [parentFormGroup]="formGroup"
    [id]="formElementModels['hasDutyOfCandourMeetingBeenPlanned'].id"
    [formElementModel]="formElementModels['hasDutyOfCandourMeetingBeenPlanned']"
  >
  </app-yes-no>
  <app-date
    class="col-6 section-col"
    *ngIf="showDutyOfCandourDetails"
    id="dateOfMeeting"
    formElementId="dateOfMeeting"
    label="Date of Duty of Candour meeting?"
    errorLabel="Date of Duty of Candour meeting"
    [parentFormGroup]="formGroup"
  >
  </app-date>
</div>
<div class="row section-row" *ngIf="showDutyOfCandourDetails">
  <div class="col section-col">
    <app-rich-text-editor
      [id]="formElementModels['supportFromEverlight'].id"
      [formElementModel]="formElementModels['supportFromEverlight']"
      [parentFormGroup]="formGroup"
    >
    </app-rich-text-editor>
  </div>
</div>
<div class="row section-row" *ngIf="showDutyOfCandourDetails">
  <div class="col section-col">
    <app-rich-text-editor
      [id]="formElementModels['lessonsLearnt'].id"
      [formElementModel]="formElementModels['lessonsLearnt']"
      [parentFormGroup]="formGroup"
    >
    </app-rich-text-editor>
  </div>
</div>
